export enum DefaultMarketLanguagesEnum {
  fr = 'fr-fr',
  de = 'de-de',
  nl = 'nl-nl',
  be = 'be-vl',
  in = 'in-en',
}